export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "ZU",
	},
	venusaur: {
		tier: "UUBL",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "ZUBL",
	},
	charizard: {
		tier: "UUBL",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "PU",
	},
	blastoise: {
		tier: "UU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "ZU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "ZUBL",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "NU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "PU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "NU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "PU",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		tier: "UU",
	},
	raichu: {
		tier: "NUBL",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "UU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "ZU",
	},
	nidoqueen: {
		tier: "UU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "OU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "PU",
	},
	clefable: {
		tier: "UUBL",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "NU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "NU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "PU",
	},
	crobat: {
		tier: "UU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NU",
	},
	vileplume: {
		tier: "UU",
	},
	bellossom: {
		tier: "UU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "ZU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "PU",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		tier: "NU",
	},
	meowth: {
		tier: "ZU",
	},
	persian: {
		tier: "NU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "NUBL",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "NU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "UU",
	},
	poliwag: {
		tier: "ZUBL",
	},
	poliwhirl: {
		tier: "PUBL",
	},
	poliwrath: {
		tier: "NUBL",
	},
	politoed: {
		tier: "UU",
	},
	abra: {
		tier: "PU",
	},
	kadabra: {
		tier: "UU",
	},
	alakazam: {
		tier: "OU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "PU",
	},
	machamp: {
		tier: "OU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "ZU",
	},
	victreebel: {
		tier: "UU",
	},
	tentacool: {
		tier: "ZU",
	},
	tentacruel: {
		tier: "UUBL",
	},
	geodude: {
		tier: "PU",
	},
	graveler: {
		tier: "NU",
	},
	golem: {
		tier: "OU",
	},
	ponyta: {
		tier: "ZU",
	},
	rapidash: {
		tier: "NU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "UU",
	},
	slowking: {
		tier: "UU",
	},
	magnemite: {
		tier: "NU",
	},
	magneton: {
		tier: "UU",
	},
	farfetchd: {
		tier: "PU",
	},
	doduo: {
		tier: "ZU",
	},
	dodrio: {
		tier: "UU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "NU",
	},
	grimer: {
		tier: "ZU",
	},
	muk: {
		tier: "UU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "OU",
	},
	gastly: {
		tier: "PU",
	},
	haunter: {
		tier: "UU",
	},
	gengar: {
		tier: "OU",
	},
	onix: {
		tier: "ZU",
	},
	steelix: {
		tier: "OU",
	},
	drowzee: {
		tier: "PU",
	},
	hypno: {
		tier: "UU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "NU",
	},
	voltorb: {
		tier: "PU",
	},
	electrode: {
		tier: "UU",
	},
	exeggcute: {
		tier: "NU",
	},
	exeggutor: {
		tier: "OU",
	},
	cubone: {
		tier: "PU",
	},
	marowak: {
		tier: "OU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "NU",
	},
	hitmonchan: {
		tier: "PU",
	},
	hitmontop: {
		tier: "NU",
	},
	lickitung: {
		tier: "NU",
	},
	koffing: {
		tier: "ZU",
	},
	weezing: {
		tier: "NU",
	},
	rhyhorn: {
		tier: "PU",
	},
	rhydon: {
		tier: "OU",
	},
	chansey: {
		tier: "UU",
	},
	blissey: {
		tier: "OU",
	},
	tangela: {
		tier: "PU",
	},
	kangaskhan: {
		tier: "UUBL",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "PU",
	},
	kingdra: {
		tier: "UUBL",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "PU",
	},
	staryu: {
		tier: "ZUBL",
	},
	starmie: {
		tier: "OU",
	},
	mrmime: {
		tier: "UU",
	},
	scyther: {
		tier: "UU",
	},
	scizor: {
		tier: "UUBL",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "OU",
	},
	elekid: {
		tier: "PU",
	},
	electabuzz: {
		tier: "UU",
	},
	magby: {
		tier: "ZU",
	},
	magmar: {
		tier: "NU",
	},
	pinsir: {
		tier: "UU",
	},
	tauros: {
		tier: "UUBL",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
	},
	lapras: {
		tier: "UUBL",
	},
	ditto: {
		tier: "ZU",
	},
	eevee: {
		tier: "ZUBL",
	},
	vaporeon: {
		tier: "OU",
	},
	jolteon: {
		tier: "OU",
	},
	flareon: {
		tier: "NU",
	},
	espeon: {
		tier: "UUBL",
	},
	umbreon: {
		tier: "OU",
	},
	porygon: {
		tier: "NU",
	},
	porygon2: {
		tier: "(OU)",
	},
	omanyte: {
		tier: "ZU",
	},
	omastar: {
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "UU",
	},
	aerodactyl: {
		tier: "UU",
	},
	snorlax: {
		tier: "OU",
	},
	articuno: {
		tier: "UUBL",
	},
	zapdos: {
		tier: "OU",
	},
	moltres: {
		tier: "UUBL",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NU",
	},
	dragonite: {
		tier: "UUBL",
	},
	mewtwo: {
		tier: "Uber",
	},
	mew: {
		tier: "Uber",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "PU",
	},
	meganium: {
		tier: "UUBL",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "ZU",
	},
	typhlosion: {
		tier: "UUBL",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "ZU",
	},
	feraligatr: {
		tier: "UU",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "PU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "PU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "NU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "ZUBL",
	},
	chinchou: {
		tier: "NU",
	},
	lanturn: {
		tier: "UU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "ZU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "NU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "PU",
	},
	ampharos: {
		tier: "UU",
	},
	marill: {
		tier: "LC",
	},
	azumarill: {
		tier: "PU",
	},
	sudowoodo: {
		tier: "NU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "UU",
	},
	aipom: {
		tier: "ZU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "PU",
	},
	yanma: {
		tier: "ZU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "UU",
	},
	murkrow: {
		tier: "PU",
	},
	misdreavus: {
		tier: "OU",
	},
	unown: {
		tier: "ZU",
	},
	wobbuffet: {
		tier: "ZU",
	},
	girafarig: {
		tier: "UU",
	},
	pineco: {
		tier: "NU",
	},
	forretress: {
		tier: "OU",
	},
	dunsparce: {
		tier: "PU",
	},
	gligar: {
		tier: "UU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "UU",
	},
	qwilfish: {
		tier: "UU",
	},
	shuckle: {
		tier: "NU",
	},
	heracross: {
		tier: "OU",
	},
	sneasel: {
		tier: "PU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "UUBL",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "PU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "UU",
	},
	corsola: {
		tier: "PU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "NU",
	},
	delibird: {
		tier: "PU",
	},
	mantine: {
		tier: "ZUBL",
	},
	skarmory: {
		tier: "OU",
	},
	houndour: {
		tier: "PU",
	},
	houndoom: {
		tier: "UUBL",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UUBL",
	},
	stantler: {
		tier: "NU",
	},
	smeargle: {
		tier: "UUBL",
	},
	miltank: {
		tier: "OU",
	},
	raikou: {
		tier: "OU",
	},
	entei: {
		tier: "UUBL",
	},
	suicune: {
		tier: "OU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NU",
	},
	tyranitar: {
		tier: "OU",
	},
	lugia: {
		tier: "Uber",
	},
	hooh: {
		tier: "Uber",
	},
	celebi: {
		tier: "Uber",
	},
};
